module.exports = __webpack_public_path__ + "img/list8.5e7b779c.jpg";